import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "testId", "additionalContentEl"],
    _excluded2 = ["children", "height", "align"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled2 from "styled-components";
import _styled from "styled-components";
import { animated } from '@react-spring/web';
import { useMobileNavbarCrossingAnimation } from './hooks/use-navbar-crossing-animation';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var Navbar = function Navbar(_ref) {
  var children = _ref.children,
      testId = _ref.testId,
      additionalContentEl = _ref.additionalContentEl,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var _useMobileNavbarCross = useMobileNavbarCrossingAnimation(),
      hasCrossedNavbar = _useMobileNavbarCross.hasCrossedNavbar;

  return /*#__PURE__*/_jsxs(StyledNavbar, _objectSpread(_objectSpread({
    "data-cy": testId
  }, _objectSpread(_objectSpread({}, restProps), {}, {
    hasCrossed: hasCrossedNavbar
  })), {}, {
    id: "navbarContainer",
    children: [children, additionalContentEl]
  }));
};
export var containerHeightMapping = {
  "default": {
    "height": "74px",
    "maxHeight": "74px",
    "paddingTop": "1rem",
    "paddingBottom": "1rem",
    "@media (min-width: 768px)": {
      "height": "88px",
      "maxHeight": "88px"
    }
  },
  'nav-open': {
    "height": "116px",
    "maxHeight": "116px",
    "paddingTop": "1.5rem",
    "paddingBottom": "1rem",
    "@media (min-width: 768px)": {
      "height": "120px",
      "maxHeight": "120px",
      "paddingTop": "1.5rem",
      "paddingBottom": "1rem"
    },
    "@media (min-width: 1024px)": {
      "height": "88px",
      "maxHeight": "88px"
    }
  }
};
export var alignMapping = {
  start: {
    "alignItems": "flex-start"
  },
  center: {
    "alignItems": "center"
  },
  end: {
    "alignItems": "flex-end"
  }
};
export var Container = function Container(_ref2) {
  var children = _ref2.children,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? 'default' : _ref2$height,
      _ref2$align = _ref2.align,
      align = _ref2$align === void 0 ? 'center' : _ref2$align,
      restProps = _objectWithoutProperties(_ref2, _excluded2);

  var _useMobileNavbarCross2 = useMobileNavbarCrossingAnimation(),
      hasCrossedNavbar = _useMobileNavbarCross2.hasCrossedNavbar,
      navbarAnimation = _useMobileNavbarCross2.navbarAnimation;

  return /*#__PURE__*/_jsx(StyledContainer, _objectSpread(_objectSpread({
    height: height,
    align: align
  }, restProps), {}, {
    style: hasCrossedNavbar ? navbarAnimation : undefined,
    children: children
  }));
};
export var StyledNavbar = /*#__PURE__*/_styled.nav.withConfig({
  displayName: "navigation-bar-styled__StyledNavbar",
  componentId: "sc-121jfnj-0"
})(["", " ", " ", ";", " ", " ", ""], {
  "zIndex": "50",
  "width": "100%"
}, function (_ref3) {
  var _ref3$background = _ref3.background,
      background = _ref3$background === void 0 ? 'white' : _ref3$background,
      hasCrossed = _ref3.hasCrossed;
  return {
    white: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))"
    },
    'purple-gradient': {
      "backgroundImage": "linear-gradient(149.71deg, #673EAE 1.59%, #44257D 90.79%)"
    },
    'home-mobile-nav': hasCrossed ? {
      "backgroundImage": "linear-gradient(to right, #5E37A0 0%, 8.620689809322357%, #5F38A2 17.241379618644714%, 58.62068980932236%, #5A349B 100%)"
    } : {
      "backgroundColor": "transparent"
    }
  }[background];
}, function (_ref4) {
  var _ref4$position = _ref4.position,
      position = _ref4$position === void 0 ? 'fixed' : _ref4$position;
  return {
    fixed: {
      "position": "fixed"
    },
    relative: {
      "position": "relative"
    }
  }[position];
}, function (_ref5) {
  var _ref5$hasBorderedBott = _ref5.hasBorderedBottom,
      hasBorderedBottom = _ref5$hasBorderedBott === void 0 ? true : _ref5$hasBorderedBott;
  return hasBorderedBottom ? {
    "borderBottomWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(229 231 235 / var(--tw-border-opacity))"
  } : {
    "borderBottomWidth": "0px"
  };
}, function (_ref6) {
  var _ref6$hasRoundedBotto = _ref6.hasRoundedBottom,
      hasRoundedBottom = _ref6$hasRoundedBotto === void 0 ? false : _ref6$hasRoundedBotto;
  return hasRoundedBottom ? {
    "borderBottomRightRadius": "1.5rem",
    "borderBottomLeftRadius": "1.5rem"
  } : {};
}, function (_ref7) {
  var twStyle = _ref7.twStyle;
  return twStyle;
});

var StyledContainer = /*#__PURE__*/_styled(animated.div).withConfig({
  displayName: "navigation-bar-styled__StyledContainer",
  componentId: "sc-121jfnj-1"
})(["", " ", " ", " ", " ", ""], {
  "boxSizing": "border-box",
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "space-between",
  "gap": "1rem",
  "@media (min-width: 768px)": {
    "justifyContent": "space-between"
  },
  "@media (min-width: 1024px)": {
    "justifyContent": "flex-start"
  }
}, function (_ref8) {
  var _ref8$justify = _ref8.justify,
      justify = _ref8$justify === void 0 ? 'start' : _ref8$justify;
  return {
    between: {
      "@media (min-width: 768px)": {
        "justifyContent": "space-between"
      }
    },
    start: {
      "@media (min-width: 768px)": {
        "justifyContent": "flex-start"
      }
    }
  }[justify];
}, function (_ref9) {
  var align = _ref9.align;
  return alignMapping[align];
}, {
  "paddingLeft": "0px",
  "paddingRight": "0px"
}, function (_ref10) {
  var height = _ref10.height;
  return containerHeightMapping[height];
});

export var HorizontalMenuWrapper = _styled2.div({
  "display": "flex",
  "alignItems": "center",
  "@media (min-width: 768px)": {
    "marginLeft": "1rem"
  },
  "@media (min-width: 1024px)": {
    "marginLeft": "0px"
  }
});